import { createFileRoute } from "@tanstack/react-router"
import { SampleViewPage } from "@/features/schema-management/pages/SampleViewPage"

function SampleViewPageWrapper() {
    const { documentTypeId, sampleId } = Route.useParams()
    return (
        <SampleViewPage
            documentTypeId={parseInt(documentTypeId)}
            sampleId={parseInt(sampleId)}
        />
    )
}

export const Route = createFileRoute("/_authenticated/agent/document/extract/$documentTypeId/$sampleId")({
    component: SampleViewPageWrapper,
})
